import { createElement } from "react";
import React from "react";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { dateHash, int32ToString, createObj, equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { EventTypeKind, EventTypeKind__get_BadgeColor, EventTypeKind__ToDescription, EventTypeKind__get_Color, deriveEventType } from "./EventType.jsx";
import { nb } from "date-fns/locale";
import { format as format_2 } from "date-fns";
import { map as map_1, filter, singleton as singleton_1, cons, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { CardFooter, Divider, Caption1Strong, Body1Strong, Button, Subtitle2, Link, CardHeader, Badge, Card, Caption1, Title3, Caption2Strong, tokens } from "@fluentui/react-components";
import { weekdayLongNb, relativeWhen, monthShortNb, weekdayShortNb } from "../Helpers.jsx";
import { equals as equals_1, compare, addDays, now, date as date_2, day } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { ArrowRightRegular, PeopleRegular, LocationRegular, ClockRegular } from "@fluentui/react-icons";
import { RouterModule_nav, RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { join } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { map, tryFind, sortBy } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { Array_groupBy } from "../fable_modules/fable-library-js.4.29.0/Seq2.js";

function HeroEventCard(heroEventCardInputProps) {
    let locale, formatOptions, locale_1, formatOptions_1, elems_1, elements, elems_3, el, el_2, el_4, elems_4, elems_7, elems_5, el_18, el_20, el_30, el_24, elems_6, el_22, el_28, el_26;
    const event = heroEventCardInputProps.event;
    const attendedIds = heroEventCardInputProps.attendedIds;
    const currentUser = heroEventCardInputProps.currentUser;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const t = deriveEventType(currentUser, attendedIds, event);
    const timeStr = `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_2(event.Time, "HH:mm", formatOptions))))}–${(locale_1 = nb, (formatOptions_1 = {}, (formatOptions_1.locale = locale_1, format_2(event.EndTime, "HH:mm", formatOptions_1))))}`;
    const location = (event.Address.length > 0) ? event.Address : event.Region.Name;
    const pillWidth = (isMobile ? 56 : 72) | 0;
    const pillNumberPx = (isMobile ? 22 : 26) | 0;
    const heroPad = (isMobile ? 14 : 18) | 0;
    const heroGap = (isMobile ? 10 : 14) | 0;
    const titlePx = (isMobile ? 17 : 18) | 0;
    const decorationSvg = createElement("div", createObj(ofArray([["aria-hidden", true], ["style", {
        position: "absolute",
        right: -50,
        top: -50,
        width: 200,
        height: 200,
        opacity: 0.12,
        pointerEvents: "none",
    }], (elems_1 = [createElement("svg", createObj(ofArray([["viewBox", (((((0 + " ") + 0) + " ") + 200) + " ") + 200], ["width", 200], ["height", 200], (elements = ofArray([createElement("circle", {
        cx: 100,
        cy: 100,
        r: 80,
        stroke: "#fff",
        strokeWidth: 1.5,
        fill: "none",
    }), createElement("circle", {
        cx: 100,
        cy: 100,
        r: 55,
        stroke: "#fff",
        strokeWidth: 1.5,
        fill: "none",
    }), createElement("circle", {
        cx: 100,
        cy: 100,
        r: 30,
        stroke: "#fff",
        strokeWidth: 1.5,
        fill: "none",
    })]), ["children", reactApi.Children.toArray(Array.from(elements))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    const metaItem = (icon, children) => createElement("span", {
        style: {
            display: "inline-flex",
            alignItems: "center",
            gap: 5 + "px ",
            minWidth: 0,
        },
        children: reactApi.Children.toArray(Array.from(cons(icon, children))),
    });
    const datePill = createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["width", pillWidth]), delay(() => append(singleton(["flexShrink", 0]), delay(() => append(singleton(["padding", (((isMobile ? 6 : 8) + "px ") + 0) + "px"]), delay(() => append(singleton(["borderRadius", 8]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["justifyContent", "center"]), delay(() => append(singleton(["gap", 2 + "px "]), delay(() => append(singleton(["lineHeight", 1]), delay(() => append(singleton(["backgroundColor", tokens.colorNeutralBackground1]), delay(() => singleton(["border", (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2]))))))))))))))))))))))))))], (elems_3 = [(el = Caption2Strong, createElement(el, {
        style: {
            color: EventTypeKind__get_Color(t),
            opacity: 0.75,
            textTransform: "uppercase",
            letterSpacing: "0.6px",
        },
        children: weekdayShortNb(event.Time),
    })), (el_2 = Title3, createElement(el_2, {
        style: {
            color: EventTypeKind__get_Color(t),
            fontSize: pillNumberPx + "px",
            fontWeight: 700,
            lineHeight: 1,
            fontVariantNumeric: "tabular-nums",
        },
        children: int32ToString(day(event.Time)),
    })), (el_4 = Caption2Strong, createElement(el_4, {
        style: {
            color: EventTypeKind__get_Color(t),
            opacity: 0.75,
        },
        children: monthShortNb(event.Time),
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    const metaRow = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: (isMobile ? 8 : 14) + "px ",
        flexWrap: "wrap",
        rowGap: "6px",
        color: tokens.colorNeutralBackgroundAlpha2,
    }], (elems_4 = toList(delay(() => {
        let el_6, el_8;
        return append(singleton(metaItem((el_6 = ClockRegular, createElement(el_6, {
            fontSize: 16,
        })), singleton_1((el_8 = Caption1, createElement(el_8, {
            style: {
                color: tokens.colorNeutralBackgroundAlpha2,
            },
            children: timeStr,
        }))))), delay(() => {
            let el_10, el_12;
            return append((location.length > 0) ? singleton(metaItem((el_10 = LocationRegular, createElement(el_10, {
                fontSize: 16,
            })), singleton_1((el_12 = Caption1, createElement(el_12, {
                style: {
                    color: tokens.colorNeutralBackgroundAlpha2,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    minWidth: 0,
                },
                children: location,
            }))))) : empty(), delay(() => {
                let el_14, el_16;
                return (event.MaxAttendees > 0) ? singleton(metaItem((el_14 = PeopleRegular, createElement(el_14, {
                    fontSize: 16,
                })), singleton_1((el_16 = Caption1, createElement(el_16, {
                    style: {
                        color: tokens.colorNeutralBackgroundAlpha2,
                    },
                    children: `${event.AttendeeCount}/${event.MaxAttendees}`,
                }))))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
    const href = RouterModule_encodeParts(ofArray(["arrangement", int32ToString(event.Id)]), 1);
    const el_32 = Card;
    return createElement(el_32, createObj(ofArray([["style", {
        padding: heroPad,
        position: "relative",
        overflow: "hidden",
        borderRadius: 10,
        border: (((1 + "px ") + "solid") + " ") + EventTypeKind__get_Color(t),
        boxShadow: tokens.shadow16,
        gap: heroGap + "px ",
        background: `linear-gradient(135deg, ${EventTypeKind__get_Color(t)} 0%, ${EventTypeKind__get_Color(t)} 55%, rgba(0,0,0,0.18) 100%), ${EventTypeKind__get_Color(t)}`,
    }], (elems_7 = [decorationSvg, createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 10 + "px ",
        position: "relative",
    }], (elems_5 = [(el_18 = Caption2Strong, createElement(el_18, {
        style: {
            color: tokens.colorNeutralForegroundStaticInverted,
            letterSpacing: "0.7px",
            textTransform: "uppercase",
        },
        children: `Mitt neste arrangement · ${EventTypeKind__ToDescription(t).toLocaleUpperCase()}`,
    })), (el_20 = Badge, createElement(el_20, {
        appearance: "outline",
        size: "medium",
        shape: "rounded",
        children: relativeWhen(event.Time),
        style: {
            color: tokens.colorNeutralForegroundStaticInverted,
            whiteSpace: "nowrap",
        },
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), (el_30 = CardHeader, createElement(el_30, {
        style: {
            position: "relative",
            alignItems: "center",
        },
        image: datePill,
        header: (el_24 = Link, createElement(el_24, createObj(ofArray([["href", href], ["style", {
            color: tokens.colorNeutralForegroundStaticInverted,
            textDecoration: "none",
        }], (elems_6 = [(el_22 = Subtitle2, createElement(el_22, {
            style: {
                display: "block",
                color: tokens.colorNeutralForegroundStaticInverted,
                fontSize: titlePx + "px",
                lineHeight: 1.25,
                letterSpacing: "-0.2px",
                wordBreak: "break-word",
            },
            children: event.Name,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_6))])])))),
        description: metaRow,
        action: (el_28 = Button, createElement(el_28, {
            as: "a",
            href: href,
            appearance: "subtle",
            icon: (el_26 = ArrowRightRegular, createElement(el_26, {})),
            "aria-label": `${event.Name}, ${EventTypeKind__ToDescription(t).toLocaleLowerCase()}, ${weekdayLongNb(event.Time)} ${day(event.Time)}. ${monthShortNb(event.Time)}, kl. ${timeStr}, ${location}`,
            style: {
                color: tokens.colorNeutralForegroundStaticInverted,
            },
        })),
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_7))])])));
}

function LaterRow(laterRowInputProps) {
    let elems, el, el_2, elems_2, el_12;
    const event = laterRowInputProps.event;
    const attendedIds = laterRowInputProps.attendedIds;
    const currentUser = laterRowInputProps.currentUser;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const t = deriveEventType(currentUser, attendedIds, event);
    let timeStart;
    const locale = nb;
    const formatOptions = {};
    formatOptions.locale = locale;
    timeStart = format_2(event.Time, "HH:mm", formatOptions);
    let timeEnd;
    const locale_1 = nb;
    const formatOptions_1 = {};
    formatOptions_1.locale = locale_1;
    timeEnd = format_2(event.EndTime, "HH:mm", formatOptions_1);
    const subtitle = join(" · ", filter((s) => (s.length > 0), ofArray([event.Course.Name, (event.Address.length > 0) ? event.Address : event.Region.Name])));
    const timeStack = createElement("div", createObj(ofArray([["style", {
        flexShrink: 0,
        minWidth: isMobile ? 44 : 52,
        textAlign: "right",
        lineHeight: 1.3,
        fontVariantNumeric: "tabular-nums",
    }], (elems = [(el = Caption1, createElement(el, {
        style: {
            display: "block",
            color: tokens.colorNeutralForeground2,
            fontWeight: 500,
        },
        children: timeStart,
    })), (el_2 = Caption1, createElement(el_2, {
        style: {
            display: "block",
            color: tokens.colorNeutralForeground3,
        },
        children: timeEnd,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    const el_14 = Card;
    return createElement(el_14, createObj(ofArray([["appearance", "subtle"], ["size", "small"], ["orientation", "horizontal"], ["onClick", (_arg) => {
        RouterModule_nav(ofArray(["arrangement", int32ToString(event.Id)]), 1, 1);
    }], ["style", createObj(toList(delay(() => append(singleton(["alignItems", "center"]), delay(() => append(singleton(["gap", (isMobile ? 8 : 12) + "px "]), delay(() => append(singleton(["padding", (((isMobile ? 9 : 10) + "px ") + (isMobile ? 10 : 12)) + "px"]), delay(() => append(singleton(["minWidth", 0]), delay(() => singleton(["cursor", "pointer"]))))))))))))], (elems_2 = [timeStack, createElement("span", {
        "aria-hidden": true,
        style: {
            width: 8,
            height: 8,
            borderRadius: 4,
            flexShrink: 0,
            backgroundColor: EventTypeKind__get_Color(t),
        },
    }), (el_12 = CardHeader, createElement(el_12, createObj(toList(delay(() => {
        let el_6, elems_1, el_4;
        return append(singleton(["header", (el_6 = Link, createElement(el_6, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["arrangement", int32ToString(event.Id)]), 1)], ["onClick", (e) => {
            e.stopPropagation();
        }], ["style", {
            color: tokens.colorNeutralForeground1,
            textDecoration: "none",
        }], (elems_1 = [(el_4 = Body1Strong, createElement(el_4, {
            style: {
                display: "block",
                color: tokens.colorNeutralForeground1,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
            },
            children: event.Name,
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))])]))))]), delay(() => {
            let el_8;
            return append((subtitle.length > 0) ? singleton(["description", (el_8 = Caption1, createElement(el_8, {
                style: {
                    display: "block",
                    color: tokens.colorNeutralForeground3,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                },
                children: subtitle,
            }))]) : empty(), delay(() => {
                let el_10;
                return !isMobile ? singleton(["action", (el_10 = Badge, createElement(el_10, createObj(ofArray([["appearance", "tint"], ["size", "small"], ["shape", "rounded"], EventTypeKind__get_BadgeColor(t), ["children", EventTypeKind__ToDescription(t)]]))))]) : empty();
            }));
        }));
    })))))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
}

/**
 * The whole "Kommende arrangementer" block as it appears on the home page:
 * section title above the card, then a card containing the hero, the
 * SENERE list grouped by date, and a footer with the type legend +
 * "Se alt" link.
 */
export function AgendaSection(agendaSectionInputProps) {
    let matchValue, elems_1, el_4, elems_13;
    const events = agendaSectionInputProps.events;
    const attendedIds = agendaSectionInputProps.attendedIds;
    const currentUser = agendaSectionInputProps.currentUser;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const cardPad = ((equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []))) ? 14 : 20) | 0;
    const legendKinds = ((matchValue = currentUser.Role, (matchValue.tag === 1) ? true : ((matchValue.tag === 2) ? true : (matchValue.tag === 3)))) ? ofArray([new EventTypeKind(0, []), new EventTypeKind(1, []), new EventTypeKind(2, [])]) : ofArray([new EventTypeKind(1, []), new EventTypeKind(2, [])]);
    const today = date_2(now());
    const limit = addDays(today, 60);
    const upcoming = sortBy((_arg) => _arg.Time, events.filter((e) => {
        if (compare(date_2(e.Time), today) >= 0) {
            return compare(date_2(e.Time), limit) <= 0;
        }
        else {
            return false;
        }
    }), {
        Compare: compare,
    });
    const heroEvent = tryFind((e_1) => {
        const kind = deriveEventType(currentUser, attendedIds, e_1);
        if (equals(kind, new EventTypeKind(0, []))) {
            return true;
        }
        else {
            return equals(kind, new EventTypeKind(1, []));
        }
    }, upcoming);
    let laterList;
    if (heroEvent == null) {
        laterList = upcoming;
    }
    else {
        const hero = heroEvent;
        laterList = upcoming.filter((e_2) => (e_2.Id !== hero.Id));
    }
    const laterCountLabel = (laterList.length === 1) ? "1 arrangement" : (`${laterList.length} arrangementer`);
    const calendarLink = (label) => {
        let elems, el, el_2;
        return createElement("a", createObj(ofArray([["href", RouterModule_encodeParts(singleton_1("kalender"), 1)], ["style", {
            color: tokens.colorBrandForeground1,
            textDecoration: "none",
            display: "inline-flex",
            alignItems: "center",
            gap: 4 + "px ",
        }], (elems = [(el = Caption1Strong, createElement(el, {
            style: {
                color: tokens.colorBrandForeground1,
            },
            children: label,
        })), (el_2 = ArrowRightRegular, createElement(el_2, {
            fontSize: 16,
        }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    };
    const sectionTitle = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: 12,
    }], (elems_1 = [(el_4 = Caption1Strong, createElement(el_4, {
        style: {
            textTransform: "uppercase",
            color: tokens.colorNeutralForeground3,
        },
        children: "Kommende arrangementer",
    })), calendarLink("Åpne kalender")], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    return createElement("div", createObj(singleton_1((elems_13 = toList(delay(() => append(singleton(sectionTitle), delay(() => {
        let el_8, elems_2, el_6, el_28, elems_12;
        return (upcoming.length === 0) ? singleton((el_8 = Card, createElement(el_8, createObj(ofArray([["style", {
            padding: ((28 + "px ") + 22) + "px",
            alignItems: "center",
        }], (elems_2 = [(el_6 = Caption1, createElement(el_6, {
            style: {
                color: tokens.colorNeutralForeground3,
            },
            children: "Ingen kommende arrangementer.",
        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])]))))) : singleton((el_28 = Card, createElement(el_28, createObj(ofArray([["style", {
            padding: 0,
            overflow: "hidden",
            flexDirection: "column",
            gap: 0 + "px ",
        }], (elems_12 = toList(delay(() => {
            let matchValue_1, e_3, elems_3;
            return append((matchValue_1 = heroEvent, (matchValue_1 == null) ? singleton(defaultOf()) : ((e_3 = matchValue_1, singleton(createElement("div", createObj(ofArray([["style", {
                padding: ((((((cardPad + "px ") + cardPad) + "px ") + 16) + "px ") + cardPad) + "px",
            }], (elems_3 = [createElement(HeroEventCard, {
                currentUser: currentUser,
                attendedIds: attendedIds,
                event: e_3,
            })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))))))), delay(() => {
                let el_10;
                return append((laterList.length > 0) ? append(singleton((el_10 = Divider, createElement(el_10, {
                    appearance: "subtle",
                }))), delay(() => {
                    let elems_8;
                    return singleton(createElement("div", createObj(ofArray([["style", {
                        padding: ((((((14 + "px ") + 8) + "px ") + 6) + "px ") + 8) + "px",
                    }], (elems_8 = toList(delay(() => {
                        let elems_4, el_12, el_14;
                        return append(singleton(createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            alignItems: "baseline",
                            justifyContent: "space-between",
                            padding: ((((((0 + "px ") + 12) + "px ") + 8) + "px ") + 12) + "px",
                        }], (elems_4 = [(el_12 = Caption2Strong, createElement(el_12, {
                            style: {
                                color: tokens.colorNeutralForeground3,
                                textTransform: "uppercase",
                                letterSpacing: "0.7px",
                            },
                            children: "Senere",
                        })), (el_14 = Caption1, createElement(el_14, {
                            style: {
                                color: tokens.colorNeutralForeground3,
                            },
                            children: laterCountLabel,
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => map((tupledArg) => {
                            let elems_7;
                            const date = tupledArg[0];
                            return createElement("div", createObj(ofArray([["style", {
                                marginBottom: 4,
                            }], (elems_7 = toList(delay(() => {
                                let elems_6, el_16, el_18, elems_5, el_20;
                                return append(singleton(createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8 + "px ",
                                    padding: ((((((6 + "px ") + 12) + "px ") + 4) + "px ") + 12) + "px",
                                }], (elems_6 = [(el_16 = Caption1Strong, createElement(el_16, {
                                    style: {
                                        color: tokens.colorNeutralForeground2,
                                    },
                                    children: `${weekdayLongNb(date).toLocaleLowerCase()} ${day(date)}. ${monthShortNb(date)}`,
                                })), createElement("span", {
                                    "aria-hidden": true,
                                    style: {
                                        width: 2,
                                        height: 2,
                                        borderRadius: 1,
                                        backgroundColor: tokens.colorNeutralForeground4,
                                    },
                                }), (el_18 = Caption1, createElement(el_18, {
                                    style: {
                                        color: tokens.colorNeutralForeground3,
                                    },
                                    children: relativeWhen(date),
                                })), createElement("div", createObj(ofArray([["style", {
                                    flexGrow: 1,
                                    marginLeft: 6,
                                }], (elems_5 = [(el_20 = Divider, createElement(el_20, {
                                    appearance: "subtle",
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => map((event) => createElement(LaterRow, {
                                    currentUser: currentUser,
                                    attendedIds: attendedIds,
                                    event: event,
                                }), tupledArg[1])));
                            })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
                        }, Array_groupBy((_arg_1) => date_2(_arg_1.Time), laterList, {
                            Equals: equals_1,
                            GetHashCode: dateHash,
                        }))));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
                })) : empty(), delay(() => {
                    let el_22;
                    return append(singleton((el_22 = Divider, createElement(el_22, {
                        appearance: "subtle",
                    }))), delay(() => {
                        let el_26, elems_11, elems_10;
                        return singleton((el_26 = CardFooter, createElement(el_26, createObj(ofArray([["style", {
                            padding: ((((((12 + "px ") + cardPad) + "px ") + 16) + "px ") + cardPad) + "px",
                            alignItems: "center",
                            flexWrap: "wrap",
                            gap: 10 + "px ",
                        }], ["action", calendarLink("Se alt")], (elems_11 = [createElement("div", createObj(ofArray([["style", {
                            display: "inline-flex",
                            alignItems: "center",
                            gap: 12 + "px ",
                            flexWrap: "wrap",
                        }], (elems_10 = toList(delay(() => map_1((kind_1) => {
                            let elems_9, el_24;
                            return createElement("span", createObj(ofArray([["style", {
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 5 + "px ",
                            }], (elems_9 = [createElement("span", {
                                "aria-hidden": true,
                                style: {
                                    width: 7,
                                    height: 7,
                                    borderRadius: 4,
                                    backgroundColor: EventTypeKind__get_Color(kind_1),
                                },
                            }), (el_24 = Caption1, createElement(el_24, {
                                style: {
                                    color: tokens.colorNeutralForeground3,
                                },
                                children: EventTypeKind__ToDescription(kind_1),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])));
                        }, legendKinds))), ["children", reactApi.Children.toArray(Array.from(elems_10))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_11))])])))));
                    }));
                }));
            }));
        })), ["children", reactApi_1.Children.toArray(Array.from(elems_12))])])))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_13))]))));
}

//# sourceMappingURL=UpcomingEvents.jsx.map
